module.exports = __webpack_public_path__ + "img/ceramic-blue.91698294.png";